import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import ArtifactSizeIcon from '../../static/images/artifacts/artifact_size.svg'
import ArtifactSizeSmall from '../../static/images/artifacts/icon_artifact-size_small.svg'
import ArtifactSizeMedium from '../../static/images/artifacts/icon_artifact-size_medium.svg'
import ArtifactSizeLarge from '../../static/images/artifacts/icon_artifact-size_large.svg'
import ArtifactSizeIconOrange from '../../static/images/artifacts/icon_artifact_size_orange.svg'
import ArtifactSizeSmallOrange from '../../static/images/artifacts/icon_artifact_small_orange.svg'
import ArtifactSizeMediumOrange from '../../static/images/artifacts/icon_artifact_medium_orange.svg'
import ArtifactSizeLargeOrange from '../../static/images/artifacts/icon_artifact_large_orange.svg'
import { isCurrentOrganizationArtifactSizeEnabled } from '../../selectors/organization'

export const ArtifactSizeStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => props.colored ? '20px' : '16px'};
  width: ${props => props.colored ? '18px' : '13px'};
  background: ${props => `url(${props.icon}) no-repeat`};
`

const defaultWrapperStyle = {
  position: 'absolute',
  bottom: 0,
  right: -6
}

export const ArtifactSize = ({
  displayArtifactSize,
  size,
  wrapperStyle,
  alwaysDisplayIcon,
  colored
}) => {
  let icon = displayArtifactSize && size && getArtifactSizeIcon(size, colored)

  if (alwaysDisplayIcon && !icon) {
    icon = colored ? ArtifactSizeIconOrange : ArtifactSizeIcon
  }

  return icon ? (
    <div style={wrapperStyle || defaultWrapperStyle}>
      <ArtifactSizeStyled icon={icon} colored={colored} />
    </div>
  ) : null
}

export const getArtifactSizeIcon = (size, colored) => {
  const sizeIdentifier = size.charAt(0).toLowerCase()
  let retVal

  switch (sizeIdentifier) {
    case 's': {
      retVal = colored ? ArtifactSizeSmallOrange : ArtifactSizeSmall
      break
    }
    case 'm': {
      retVal = colored ? ArtifactSizeMediumOrange : ArtifactSizeMedium
      break
    }
    case 'l': {
      retVal = colored ? ArtifactSizeLargeOrange : ArtifactSizeLarge
      break
    }
  }

  return retVal
}

ArtifactSize.propTypes = {
  displayArtifactSize: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  wrapperStyle: PropTypes.object,
  alwaysDisplayIcon: PropTypes.bool,
  colored: PropTypes.bool
}

export const mapStateToProps = state => ({
  displayArtifactSize: isCurrentOrganizationArtifactSizeEnabled(state)
})

export default connect(mapStateToProps)(ArtifactSize)
